import React, { Component } from 'react';
import ExpandVersionsIcon from './assets/ExpandVersions.svg';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Logo from './assets/logo.svg';
import parse from 'date-fns/parse';
import format from 'date-fns/format';
import de from 'date-fns/locale/de';

const StyledTopMenu = styled.header`
  background-color: #00024e;
  grid-area: header;
  z-index: 1;
  color: rgba(255, 255, 255, 0.8);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
`;

const TopMenuTabs = styled.ul`
  margin: 0;
  padding: 0 2rem;
  list-style: none;
  height: 97px;
  display: grid;
  grid-gap: 0 20px;
  grid-template-columns: 1fr 1fr auto;
  align-items: center;
`;

const TopMenuTab = styled.li`
  display: grid;
`;

const StyledLogo = styled.img`
  width: 210px;
  height: 45px;
`;

const StyledTitle = styled.h1`
  font-family: latoregular;
`;

const StyledDate = styled.span`
  font-family: latoregular;
`;

const TopMenuTabLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  justify-self: start;
  justify-content: start;
  grid-column-gap: 1rem;
  border-bottom: 1px solid transparent;
`;

const StyledTopMenuContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
`;

const TopMenuLink = styled.a`
  text-decoration: none;
  color: inherit;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  font-family: latoregular;
  justify-content: start;
  border: 1px solid rgba(255, 255, 255, 0.8);
  padding: 0.3em 0.7em 0.4em 0.7em;
  border-radius: 5px;
  cursor: pointer;
  &:hover,
  &:focus {
    background-color: rgba(255, 255, 255, 0.2);
    color: white;
  }

  @media print {
    display: none !important;
  }
`;

const StyledSelect = styled.select`
  appearance: none;
  &::-ms-expand {
    display: none;
  }
  background-color: transparent;
  padding: 10px 26px 10px 20px;
  font-family: latolight;
  color: rgba(255, 255, 255, 0.7);
  border-radius: 5px;
  border: 0;
  background-image: url(${ExpandVersionsIcon});
  background-repeat: no-repeat;
  background-position: calc(100% - 10px) calc(100% - 14px);
`;

const StyledOption = styled.option`
  color: black;
`;

class TopMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.switchVersion = this.switchVersion.bind(this);
  }

  switchVersion(event) {
    const newVersionString = event.target.value;
    this.props.history.push(
      `/reports/${this.props.selectedReportId}/v/${newVersionString}/pages/${
        this.props.selectedReportPageId
      }/tabs/${this.props.selectedReportTabId}`
    );
  }

  render() {
    const clientName = this.props.report.data_provider.client;

    return (
      <StyledTopMenu>
        <nav>
          <TopMenuTabs>
            <TopMenuTab>
                <TopMenuTabLink to={`/reports`}>
                    <StyledTopMenuContent>
                        <StyledLogo src={Logo} alt="logo" />
                    </StyledTopMenuContent>
                </TopMenuTabLink>
            </TopMenuTab>

            {this.props.versionSwitcher ? (
              <TopMenuTab>
                <StyledSelect
                  value={this.props.selectedReportVersionString}
                  onChange={this.switchVersion}
                >
                  {this.props.report.data_provider.versions.map(version => (
                    <StyledOption key={version.version} value={version.version}>
                      {version.short_description}
                    </StyledOption>
                  ))}
                </StyledSelect>
              </TopMenuTab>
            ) : (
              <TopMenuTab>
                <StyledDate>
                  letztes Update:{' '}
                  {format(
                    parse(
                      this.props.report.data_provider.versions[0].data_from
                    ),
                    'DD.MM.YYYY',
                    {
                      locale: de
                    }
                  )}
                </StyledDate>
              </TopMenuTab>
            )}

            <TopMenuTab>
              <TopMenuLink href="/logout?next=%2F">Abmelden</TopMenuLink>
            </TopMenuTab>
          </TopMenuTabs>
        </nav>
      </StyledTopMenu>
    );
  }
}

export default TopMenu;
